import { useEffect, useRef } from "react";

// Fila de "donos" de paste ativos no momento, ordenada do mais prioritário (menor priority) ao menos
let activeOwners = [];
let globalListenerAttached = false;

// Único ouvinte global (fase de captura): roda antes de qualquer ouvinte de bubble já existente na
// página (ex: o document.addEventListener("paste") de AnexosCircuito), então decide se intercepta
const handleGlobalPaste = (evento) => {
  const arquivos = Array.from(evento?.clipboardData?.files || []);
  if (!arquivos?.length) return;
  const owner = activeOwners?.[0];
  if (!owner) return;
  evento?.preventDefault?.();
  evento?.stopPropagation?.();
  owner?.onPasteFiles?.(arquivos);
};

const attachGlobalListenerIfNeeded = () => {
  if (globalListenerAttached) return;
  document?.addEventListener?.("paste", handleGlobalPaste, true);
  globalListenerAttached = true;
};

const detachGlobalListenerIfIdle = () => {
  if (activeOwners?.length === 0 && globalListenerAttached) {
    document?.removeEventListener?.("paste", handleGlobalPaste, true);
    globalListenerAttached = false;
  }
};

// Resolve conflitos de Ctrl+V entre múltiplas áreas de colar da mesma página (ex: o modal de
// equipamento personalizado, o inspector de nó do diagrama e os anexos do circuito), sem depender
// de qual elemento está com foco no DOM. Enquanto `active` for true, este consumidor entra na fila
// de prioridade; o de menor `priority` intercepta o Ctrl+V global antes dos demais ouvintes da página.
// Sem nenhum consumidor ativo, o paste segue seu fluxo normal (ex: cai no listener de AnexosCircuito).
export default function usePriorityPaste({
  active = false,
  priority = 0,
  onPasteFiles = () => {},
}) {
  const ownerRef = useRef({ priority, onPasteFiles });
  ownerRef.current.priority = priority;
  ownerRef.current.onPasteFiles = onPasteFiles;

  useEffect(() => {
    if (!active) return undefined;
    const owner = ownerRef.current;
    activeOwners = [...activeOwners, owner].sort(
      (a, b) => a?.priority - b?.priority,
    );
    attachGlobalListenerIfNeeded();

    return () => {
      activeOwners = activeOwners.filter((item) => item !== owner);
      detachGlobalListenerIfIdle();
    };
  }, [active]);
}
